/**
 * Brewvana — Bali Coffee Pods Hero Image A/B Test
 * Experiment ID : bv-bali-hero-v1
 * Variant A     : Lifestyle bag shot (control  — media 37166305869985)
 * Variant B     : K-Cup style pods shot (treatment — media 37166913421473, default display)
 *
 * Assignment    : 50/50, sticky via localStorage
 * Tracking      : GA4 gtag + dataLayer (GTM compatible)
 * Events fired  :
 *   ab_experiment_view  — on page load (non-interaction)
 *   ab_add_to_cart      — on ATC button click
 */
(function () {
  'use strict';

  /* ── Config ─────────────────────────────────────────────────────────────── */
  var EXP_ID       = 'bv-bali-hero-v1';
  var STORAGE_KEY  = 'bv_ab_bali_hero';
  var PRODUCT_PATH = '/products/bali-coffee-pods';
  /* Emergency kill switch: set window.__bvAbKill = true to halt test instantly */
  if (window.__bvAbKill === true) return;


  /* Shopify MediaImage IDs on the Bali product page */
  var MEDIA_A = '37166305869985'; /* Control   – existing lifestyle shot       */
  var MEDIA_B = '37166913421473'; /* Treatment – K-Cup style pods shot (default)*/

  /* ── Guard: only execute on the Bali product page ───────────────────────── */
  if (window.location.pathname.indexOf(PRODUCT_PATH) === -1) return;

  /* ── Variant assignment (sticky per browser session) ─────────────────────── */
  var variant = localStorage.getItem(STORAGE_KEY);
  if (!variant) {
    variant = Math.random() < 0.5 ? 'A' : 'B';
    localStorage.setItem(STORAGE_KEY, variant);
  }

  /* Expose for QA / debugging */
  window.__bvAb = { exp: EXP_ID, variant: variant, mediaA: MEDIA_A, mediaB: MEDIA_B };

  /* ── GA4 + dataLayer event helper ───────────────────────────────────────── */
  function track(eventName, extra) {
    var payload = Object.assign(
      {
        experiment_id  : EXP_ID,
        variant_id     : variant,
        product_handle : 'bali-coffee-pods'
      },
      extra || {}
    );

    /* Primary: GA4 gtag */
    if (typeof gtag === 'function') {
      gtag('event', eventName, payload);
    }

    /* Fallback: GTM dataLayer */
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: eventName }, payload));
    }
  }

  /* ── Image swap — Variant A only ─────────────────────────────────────────── */
  /* Variant B keeps the default display (new pods shot already primary). */
  /* Variant A swaps to the lifestyle shot using the media-gallery API.   */
  function applyVariant() {
    if (variant !== 'A') return;

    /* Preferred: call the custom-element API (prepend = make it slot-1) */
    var gallery = document.querySelector('media-gallery');
    if (gallery && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(MEDIA_A, /* prepend = */ true);
      return;
    }

    /* Fallback: directly manipulate the viewer DOM */
    var viewer = document.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    /* Remove active flag from all media items */
    viewer.querySelectorAll('[data-media-id]').forEach(function (el) {
      el.classList.remove('is-active');
    });

    /* Activate and prepend the control image */
    var target = viewer.querySelector('[data-media-id="' + MEDIA_A + '"]');
    if (target) {
      target.classList.add('is-active');
      if (target.parentElement.firstChild !== target) {
        target.parentElement.prepend(target);
      }
    }

    /* Mirror swap in thumbnail strip */
    var thumbs = document.querySelector('[id^="GalleryThumbnails"]');
    if (thumbs) {
      var thumbTarget = thumbs.querySelector('[data-target="' + MEDIA_A + '"]');
      if (thumbTarget && thumbTarget.parentElement.firstChild !== thumbTarget) {
        thumbTarget.parentElement.prepend(thumbTarget);
      }
    }
  }

  /* ── Add-to-cart click tracking ─────────────────────────────────────────── */
  function bindAtcTracking() {
    var selectors = [
      'product-form [name="add"]',
      'product-form [type="submit"]',
      'form[action*="/cart/add"] [name="add"]',
      'form[action*="/cart/add"] [type="submit"]',
      '.product-form__submit'
    ];

    selectors.forEach(function (sel) {
      var btn = document.querySelector(sel);
      if (btn && !btn.dataset.bvAbBound) {
        btn.dataset.bvAbBound = '1';
        btn.addEventListener('click', function () {
          track('ab_add_to_cart');
        });
      }
    });
  }

  /* ── Init ────────────────────────────────────────────────────────────────── */
  function init() {
    applyVariant();
    track('ab_experiment_view', { non_interaction: true });
    bindAtcTracking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-apply after deferred/lazy rendering (theme hydration delay) */
  setTimeout(function () { applyVariant(); bindAtcTracking(); }, 700);
})();